var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-button',{staticClass:"report-download-button",attrs:{"variant":"secondary","loading":_vm.isDownloadInProgress,"disabled":_vm.isDownloadInProgress || _vm.isReportLoading},on:{"click":_vm.downloadReport}},[_vm._v("Download\n")])}
var staticRenderFns = []

export { render, staticRenderFns }